var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.75 1.75a.75.75 0 00-1.5 0v6.69L5.03 6.22a.75.75 0 00-1.06 1.06l3.5 3.5a.75.75 0 001.06 0l3.5-3.5a.75.75 0 00-1.06-1.06L8.75 8.44V1.75zm-6 10.75a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H2.75z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTguNzUgMS43NWEuNzUuNzUgMCAwIDAtMS41IDB2Ni42ODkzTDUuMDMwMyA2LjIxOTdhLjc1Ljc1IDAgMCAwLTEuMDYwNiAxLjA2MDZsMy41IDMuNWEuNzQ5OC43NDk4IDAgMCAwIDEuMDYwNiAwbDMuNS0zLjVhLjc1Ljc1IDAgMCAwLTEuMDYwNi0xLjA2MDZMOC43NSA4LjQzOTNWMS43NVptLTYgMTAuNzVhLjc1Ljc1IDAgMCAwIDAgMS41aDEwLjVhLjc1Ljc1IDAgMCAwIDAtMS41SDIuNzVaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";
export { SvgDownloadOutline16 as ReactComponent };